import { useTheme } from "../../../contexts/useTheme";
import dashcoreDarkMode from "../../../assets/dashcore-dark-mode.png";
import dashcoreLightMode from "../../../assets/dashcore-light-mode.png";

interface Props {
  className?: string;
  style?: React.CSSProperties;
}

export const ThemedLogo = ({ className, style }: Props) => {
  const { currentTheme } = useTheme();
  const isDark = !currentTheme.startsWith("light_");

  return (
    <img
      src={isDark ? dashcoreDarkMode : dashcoreLightMode}
      alt="DashCore AI"
      className={className}
      style={style}
    />
  );
};
